import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import CategoryNav from './components/CategoryNav';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/manhua';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: 'http://youplz.com/',
        description: siteInfo.description,
        email: siteInfo.email,
        telephone: siteInfo.phone,
        address: {
          '@type': 'PostalAddress',
          streetAddress: siteInfo.address,
        },
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: 'http://youplz.com/',
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          'target': 'http://youplz.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '韩漫网 - 首页',
        description: '韩漫漫画网站，免费观看下拉式，漫画韩漫网址，韩漫网，免费观看下拉式漫画和韩漫资源，网站稳定内容全面，无需下载即可畅读',
        url: 'http://youplz.com/',
        isPartOf: { '@type': 'WebSite', name: siteInfo.name },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <HotRanking />
        <LatestUpdates />
        <CategoryNav />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}